import React from "react";
import Draggable from 'react-draggable';

// Shared components and utilities
import { Utils, OmniDropdownComponent, OmniIconComponent } from "../../../../shared";

export default class HierarchyFilterComponent extends React.Component {

    defaultState = {
        filterData: {
            templateName: '',
            status: [],
            campaignEnd: '',
            mediaOpsState: [],
            campaignStart: '',
            updatedAt: '',
            updatedBy: '',
        },
        enableFilter: false,
    }
    
    statusOptions = [ 'Active', 'Inactive' ];
    mediaOpsStateOptions = ['Saved', 'Submitted'];

    constructor(props) {
        super(props);
        this.state = this.defaultState
        this.nodeRef = React.createRef();
    }

    toggleFilter = () => {
        this.setState({ enableFilter: !this.state.enableFilter });
    }

    /**
     * Clear all the filters and close the filter panel
     * @returns {void}
     */
    clearAll = () => {
        const value = {};
        this.props.onApplyFilter(value)
        this.setState({ filterData: this.defaultState.filterData });
        this.toggleFilter();
    }

    /**
     * Update the filter data on change of input
     * @param {string} type - type of input
     * @param {object} event - event object
     * @returns {void}
     */
    onDataChange = (type, event) => {
        let value = event.target.value;
        let filterData = {...this.state.filterData};

        if (type === "campaignStart" || type === "campaignEnd" || type === "updatedAt") {
            value = Utils.formatDateObject(value);
            filterData = { ...filterData, [type]: value }
        } else{
            filterData = { ...filterData, [type]: value }
        }        
        this.setState({ filterData })
    }

    /**
     * Apply the filter and close the filter panel
     * @returns {void}
     */
    applyFilter = () => {
        const filteredData = {};
        const data = this.state.filterData;

        for(const key in data){
            const value = Array.isArray(data[key]) ? data[key][0] : data[key];
            if(value && value !== ''){
                filteredData[key] = value;
            }
        }

        this.props.onApplyFilter(filteredData)
        this.toggleFilter();
    }

    /**
     * Disable the apply button if all the filters are empty
     * @returns {boolean}
     */
    disableApplyButton = () => (Object.values(this.state.filterData).every((item)=> !item));

    render() {

        return (
            <>
                <omni-tooltip>
                    <button slot="invoker" className={`button is-text is-shadowless ${this.state.enableFilter ? 'is-active' : ''}`}
                        onClick={this.toggleFilter}>
                        <OmniIconComponent className="is-size-2" icon-id="omni:interactive:filter" />
                    </button>
                    <span slot="content">Filters</span>
                </omni-tooltip>
                {this.state.enableFilter &&
                    <Draggable nodeRef={this.nodeRef} axis="both" bounds='body' defaultPosition={{ x: -200, y: 285 }}>
                        <div ref={this.nodeRef}>
                            <div className="hierarchy-filter-container">
                                <div className="hierarchy-filter-header">
                                    <span className='filter-title'>Filters</span>
                                    <omni-tooltip>
                                        <button slot="invoker" className="button is-text is-shadowless hierarchy-filter-close"
                                            onClick={this.toggleFilter}>
                                            <OmniIconComponent className="is-size-1" icon-id="omni:interactive:close" />
                                        </button>
                                        <span slot="content">Close</span>
                                    </omni-tooltip>
                                </div>
                                <hr className="hierarchy-filter-devider" />
                                <div className="hierarchy-filter-body">
                                    <button className="clear-all-button is-primary" onClick={this.clearAll}>Clear All</button>
                                    <section className="filter-name-section flex-column">
                                        <span className="field-text-label">Template Name</span>
                                        <input type="text" placeholder="Template Name" className="input"
                                        value={this.state.filterData['templateName']} 
                                        onChange={(event)=> this.onDataChange('templateName', event)} />
                                    </section>
                                    <section className="filter-state-section flex-column">
                                        <span className="field-text-label">Mediaops State</span>
                                        <OmniDropdownComponent
                                            typeahead
                                            searchindropdown
                                            hidefooter
                                            className="width-100"
                                            placeholder="Select Option"
                                            options={this.mediaOpsStateOptions}
                                            id="hierarchy-filter-state-dropdown"
                                            value={this.state.filterData['mediaOpsState']}
                                            onDropdownChange={(event) => this.onDataChange("mediaOpsState", event)}
                                            />
                                    </section>
                                    <section className="filter-status-section flex-column">
                                        <span className="field-text-label">Status</span>
                                        <OmniDropdownComponent
                                            hidefooter
                                            className="width-100"
                                            placeholder="Select Option"
                                            options={this.statusOptions}
                                            id="hierarchy-filter-status-dropdown"
                                            value={this.state.filterData['status']}
                                            onDropdownChange={(event) => this.onDataChange("status", event)}
                                            />
                                    </section>
                                    <section className="filter-date-section flex-row">
                                        <div className="start-date-field flex-column width-50 position-relative">
                                            <span className="field-text-label">Start Date</span>
                                            <input type="date" 
                                            data-date={this.state.filterData['campaignStart'] ? this.state.filterData['campaignStart'] : "Mon DD, YYYY"} 
                                            onChange={(event)=> this.onDataChange('campaignStart', event)} 
                                            className={this.state.filterData['campaignStart'] ? '' : 'date-light-color'}
                                            />
                                        </div>
                                        <div className="end-date-field flex-column width-50 position-relative">
                                            <span className="field-text-label">End Date</span>
                                            <input type="date" 
                                            data-date={this.state.filterData['campaignEnd'] ? this.state.filterData['campaignEnd'] : "Mon DD, YYYY"} 
                                            onChange={(event)=> this.onDataChange('campaignEnd', event)}
                                            className={this.state.filterData['campaignEnd'] ? '' : 'date-light-color'} 
                                            />
                                        </div>
                                    </section>
                                    <section className="filter-modified-by-section flex-column">
                                            <span className="field-text-label">Modified By</span>
                                            <input type="text" placeholder="Modified By" className="input" 
                                            value={this.state.filterData['updatedBy']}
                                            onChange={(event)=> this.onDataChange('updatedBy', event)} />
                                    </section>
                                    <section className="filter-modified-date-section">
                                        <div className="modified-date-field flex-column width-50 position-relative">
                                            <span className="field-text-label">Modified Date</span>
                                            <input type="date" 
                                            data-date={this.state.filterData['updatedAt'] ? this.state.filterData['updatedAt'] : "Mon DD, YYYY"} 
                                            onChange={(event)=> this.onDataChange('updatedAt', event)}
                                            className={this.state.filterData['updatedAt'] ? '' : 'date-light-color'} 
                                            />
                                        </div>
                                    </section>
                                </div>
                                <div className="hierarchy-filter-footer">
                                    <button className="button is-primary is-large" disabled={this.disableApplyButton()} onClick={this.applyFilter}>Apply Filters</button>
                                </div>
                            </div>
                        </div>
                    </Draggable>
                }
            </>
        )
    }

}